module.exports = [{
  plugin: require('/Users/fredericksilva/Downloads/aranhaagency.github.io/node_modules/gatsby-plugin-facebook-pixel/gatsby-browser.js'),
  options: {
    "plugins": [],
    "pixelId": "612142959299987"
  }
}, {
  plugin: require('/Users/fredericksilva/Downloads/aranhaagency.github.io/node_modules/gatsby-plugin-cookiehub/gatsby-browser.js'),
  options: {
    "plugins": [],
    "cookihubId": "643d82f5",
    "trackingId": "UA-141019633-4",
    "head": false,
    "anonymize": true
  }
}, {
  plugin: require('/Users/fredericksilva/Downloads/aranhaagency.github.io/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
  options: {
    "plugins": [],
    "trackingId": "UA-141019633-4"
  }
}, {
  plugin: require('/Users/fredericksilva/Downloads/aranhaagency.github.io/node_modules/gatsby-plugin-transition-link/gatsby-browser.js'),
  options: {
    "plugins": []
  }
}, {
  plugin: require('/Users/fredericksilva/Downloads/aranhaagency.github.io/gatsby-browser.js'),
  options: {
    "plugins": []
  }
}];